import { getValidAccessToken } from 'services/auth';

export const getSpeechAudioByText = async ({
  text,
  signal,
  language = "en-US"
}:
 {
  text:
  string,
  signal: AbortSignal,
  language?: "en-US" | "es-MX"
 }) => {
  const token = await getValidAccessToken();
  const response = await fetch(`${import.meta.env.VITE_API_BASE_URL!}audio/synthesize`, {
    method: 'POST',
    body: JSON.stringify({ text, language }),
    headers: {
      Accept: 'audio/mpeg',
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    signal
  });
  if (!response.ok) {
    throw new Error(`Speech synthesis failed: ${response.status}`);
  }
  return response;
};
